import PropTypes from 'prop-types'
import { mergeOverrides } from 'baseui'
import { Button } from 'baseui/button'
import { SDButtonGroupButtonOverrides } from './styled-components'
import { SDButtonGroupButtonPulseOverrides } from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { forwardRef } from 'react'

// eslint-disable-next-line react/display-name
const SDButtonGroupButton = forwardRef((props, ref) => {
  const isPulse = usePulseScope()
  const baseOverrides = isPulse ? SDButtonGroupButtonPulseOverrides() : SDButtonGroupButtonOverrides()
  const newOverrides = mergeOverrides(baseOverrides, props.overrides)

  return (
    <Button {...props} ref={ref} overrides={newOverrides}>
      {props.children}
    </Button>
  )
})

SDButtonGroupButton.propTypes = {
  overrides: PropTypes.object,
  children: PropTypes.string,
}

export default SDButtonGroupButton
